import { Dialog, DialogContent, DialogTrigger } from '../ui/dialog';
import SampleAccountHeader from '@/assets/icons/sample_account_header.svg?react';

export function SampleAccountModal() {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <div className="flex flex-col items-center justify-center p-7 text-sm">
          <p className="text-foreground font-normal">You’re viewing a sample account.</p>
          <p className="text-primary font-bold">See what that means</p>
        </div>
      </DialogTrigger>
      <DialogContent className="flex flex-col items-center gap-4">
        <SampleAccountHeader />
        <h1 className="text-2xl leading-7 font-bold">This is a sample account</h1>
        <p className="text-foreground px-5 text-sm leading-5 font-normal opacity-70">
          This means you can click around and get a feel for the app but nothing you do here is
          permanent so go have fun! Points cannot be redeemed.
        </p>
      </DialogContent>
    </Dialog>
  );
}
